/** One card of the mocked corp surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { EM_DASH, heading } from './corp-mock';

export function CommissionsCard() {
  const tiles: ReadonlyArray<{ label: string; bg: string; fg: string }> = [
    { label: 'Secured', bg: 'var(--nb-primary-soft)', fg: 'var(--nb-primary-2)' },
    { label: 'Prospective', bg: 'var(--nb-info-soft)', fg: 'var(--nb-info)' },
  ];
  return (
    <section className="nb-card" style={{ flex: '0 0 auto' }}>
      <div className="nb-card-hd">
        <h3 className="nb-display" style={heading}>
          Commissions
        </h3>
        <span className="nb-eyebrow">YTD</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        {tiles.map((t) => (
          <div key={t.label} style={{ padding: '14px 16px', background: t.bg, borderRadius: 8 }}>
            <div className="nb-eyebrow" style={{ color: t.fg, fontSize: 10 }}>
              {t.label}
            </div>
            <div
              className="nb-tabular"
              style={{ fontSize: 24, fontWeight: 700, color: t.fg, marginTop: 4 }}
            >
              {EM_DASH}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
